import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(4),
    top: theme.spacing(2),
    color: theme.palette.grey[500],
  },
  noBg: {
    backgroundColor: "transparent",
    color: "rgb(152,152,152)",
    fontSize: 18,
    fontWeight: 400,
    marginRight: "50px"
  },
  noBackground: {
    backgroundColor: "transparent",
    marginRight: "50px"
  },
  dialogWrapper: {
    zIndex: 999999,
    "& .MuiDialog-paperWidthSm": {
      width: "100%",
      borderRadius: 24,
      margin: 10
    },
  },
  dialogWrapperBottom: {
    "& .MuiDialog-scrollPaper": {
      alignItems: 'flex-end',
    },
  },
  dialogContentWrapper: {
    padding: `${theme.spacing(6, 10, 5, 10)} !important`,
  },
  dialogActionWrapper: {
    padding: `${theme.spacing(0, 8, 5, 5)} !important`,
  },
  dialogContentIcon: {
    textAlign: "center",
    "& img": {
      maxWidth: 150,
      maxHeight: 150,
    },
  },
  dialogContentIcons: {
    display: "flex",
    textAlign: "center",
    justifyContent: "center",
    "& img": {
      maxWidth: 150,
      maxHeight: 150,
    },
  },
  dialogContentImg: {
    borderRadius: "50px",
    background: "#e34141",
    padding: "14px",
  },
  dialogContentTitle: {
    fontWeight: 600,
    fontSize: 20,
    margin: theme.spacing(2, 0),
    textAlign: 'center',
  },
  dialogTitle: {
    fontWeight: 600,
    fontSize: 20,
    textAlign: 'center',
  },
  dialogHead: {
    fontWeight: 600,
    fontSize: 20,
    textAlign: 'center',
    margin: theme.spacing(0, 0, 2, 0),
  },
  dialogTitleName: {
    fontWeight: 600,
    fontSize: 14,
    textAlign: 'center',
  },
  adminInput: {
    margin: theme.spacing(2.5, 0),
    "& .MuiInputLabel-root": {
      transform: "translate(0, 1.5px) scale(1)",
      fontSize: 18,
      fontWeight: 400,
      color: "rgb(152,152,152)",
      textAlign: "center",
      position: "absolute",
      bottom: "0",
      right: "0"
    },
    "& .MuiInputBase-root": {
      height: 50,
      marginTop: "30px !important",
    },
    "& .MuiInputBase-input": {
      padding: `14px 10px`,
    },
  },
  adminInputLabel: {
    fontSize: 15,
    fontWeight: 400,
    color: "#000",
  },
  smartAppRow: {
    display: 'flex',
    alignItems: 'center',
  },
  smartAppRowIcon: {
    marginRight: theme.spacing(2),
  },
  dialogContentWrapperTop: {
    marginTop: "24px"
  },
  deleteView: {
    width: "150px",
    marginLeft: "16px !important",
    "& .MuiButton-label": {
      padding: "16px",
    }
  },
  dialogContentSubtitle: {
    fontSize: 18,
    fontWeight: 400,
    color: "rgb(152,152,152)",
    textAlign: "center"
  },
  closeReplace: {
    justifyContent: 'center !important',
  },
  replaceDialogContentWrapper: {
    padding: `${theme.spacing(6, 10, 3, 10)} !important`,
  },
  dialogOOPs: {
    marginTop: "16px",
    fontWeight: 600,
    fontSize: 20,
    textAlign: 'center',
  },
  dialogText: {
    fontSize: "18px",
    color: "#989898",
    textAlign: 'center',
    marginTop: "16px"
  },
  closeView: {
    width: "150px",
    background: "#000000",
    color: "#ffffff",
    "& .MuiButton-label": {
      padding: "16px",
    }
  },
  approveDialogContentWrapper: {
    padding: `${theme.spacing(6, 4, 3, 4)} !important`,
  },
  approveDialogActionWrapper: {
    padding: `${theme.spacing(0, 4, 5, 5)} !important`,
  },
  approveCheckList: {
    display: "flex",
    margin: "8px"
  },
  titleLabel: {
    fontSize: "14px",
    fontWeight: 500
  },
  subtitleLabel: {
    fontSize: "14px",
    color: "#989898",
    fontWeight: 100
  },
  reportTitle: {
    fontSize: "20px",
    fontWeight: 500,
    marginRight: "48px"
  },
  reportDialogContentWrapper: {
    padding: `${theme.spacing(3, 4, 3, 4)} !important`,
  },
  reportEventReason: {
    width: "100%",
    marginTop: "16px",
    "& .MuiInput-root": {
      padding: "16px"
    },
  }
}));
